"use client";

import { useSyncExternalStore } from "react";

const STORAGE_KEY = "pbd-theme";

type Theme = "dark" | "light";

const themeListeners = new Set<() => void>();

function subscribeTheme(listener: () => void) {
  themeListeners.add(listener);
  return () => themeListeners.delete(listener);
}

function readThemeSnapshot(): Theme {
  return localStorage.getItem(STORAGE_KEY) === "light" ? "light" : "dark";
}

function readServerTheme(): Theme {
  return "dark";
}

export function ThemeToggle() {
  const theme = useSyncExternalStore(subscribeTheme, readThemeSnapshot, readServerTheme);

  function toggle() {
    const next = theme === "light" ? "dark" : "light";
    document.documentElement.setAttribute("data-theme", next);
    localStorage.setItem(STORAGE_KEY, next);
    themeListeners.forEach((listener) => listener());
  }

  const isLight = theme === "light";

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label="Toggle theme"
      className="inline-flex items-center h-10 px-2.5 border border-[var(--chrome-border)] rounded bg-transparent cursor-pointer transition-[border-color] duration-150 hover:border-[color-mix(in_srgb,var(--cta)_60%,transparent)]"
    >
      <span className="relative inline-flex w-[34px] h-[18px] items-center border border-[color-mix(in_srgb,var(--cta)_42%,transparent)] rounded-full bg-[color-mix(in_srgb,var(--chrome-bg-solid)_82%,var(--dot))]">
        <span
          className="w-3 h-3 rounded-full transition-transform duration-150"
          style={{
            marginLeft: isLight ? 18 : 3,
            background: isLight ? "var(--dot)" : "var(--cta)",
            boxShadow: isLight ? "none" : "0 0 14px color-mix(in srgb, var(--cta) 42%, transparent)",
          }}
        />
      </span>
    </button>
  );
}
